import { prospectStates, prospectSubstates } from './prospects/types';

export const statesFormatted = {
  COMPLETED: 'Completado',
  IN_REVIEW: 'En revisión',
  REJECTED: 'Desestimado',
};

export const statesColors = {
  COMPLETED: 'success' as const,
  IN_REVIEW: 'warning' as const,
  REJECTED: 'error' as const,
};

export const substatesFormatted = {
  INITIAL: 'Inicial',
  NEW_DOCUMENT: 'Nuevo Documento',
  DOCUMENT_REVIEW: 'Revisión de Documento',
  DOCUMENT_CORRECTED: 'Documento Corregido',
  DOCUMENT_OBSERVED: 'Documento Observado',
  CONTRACT_PENDING: 'Contrato Pendiente',
  CONTRACT_PENDING_SIGNATURE: 'Contrato Pendiente de Firma',
  CONTRACT_PENDING_ACTIVATION: 'Contrato Firmado Pendiente de Alta',
  CONTRACT_NOT_SIGNED: 'Contrato No Firmado',
  CREDENTIALS_SENT: 'Credenciales Enviadas',
  POP_SENT: 'P.O.P. Enviado',
  COMPLETED: 'Completado',
  MISSING_DOCUMENTATION: 'Documentación Faltante',
  DOCUMENT_NOT_CORRECTED: 'Documento No Corregido',
  DISCARDED: 'Desestimado',
};

export const substatesActions: Record<string, string> = {
  CONTRACT_PENDING: 'Confeccionar contrato',
  CONTRACT_PENDING_SIGNATURE: 'Enviar contrato al Comercio',
  CONTRACT_PENDING_ACTIVATION: 'Activar contrato',
  CREDENTIALS_SENT: 'Enviar credenciales',
  POP_SENT: 'Enviar P.O.P.',
  COMPLETED: 'Completar',
  DISCARDED: 'Desestimar',
};

// export const substatesColors = {
//   INITIAL: 'warning' as const,
//   NEW_DOCUMENT: 'warning' as const,
//   DOCUMENT_REVIEW: 'warning' as const,
//   DOCUMENT_CORRECTED: 'warning' as const,
//   DOCUMENT_OBSERVED: 'warning' as const,
//   CONTRACT_PENDING: 'warning' as const,
//   CONTRACT_PENDING_SIGNATURE: 'error' as const,
//   CONTRACT_PENDING_ACTIVATION: 'error' as const,
//   CREDENTIALS_SENT: 'warning' as const,
//   POP_SENT: 'warning' as const,
//   COMPLETED: 'success' as const,
//   MISSING_DOCUMENTATION: 'error' as const,
//   DOCUMENT_NOT_CORRECTED: 'error' as const,
//   CONTRACT_SIGNATURE_PENDING: 'error' as const,
// };

export const substateOrder = [
  'CONTRACT_PENDING',
  'CONTRACT_PENDING_SIGNATURE',
  'CONTRACT_PENDING_ACTIVATION',
  'CONTRACT_NOT_SIGNED',
  'CREDENTIALS_SENT',
  'POP_SENT',
  'COMPLETED',
];

export const subTypeRelation: Record<prospectStates, prospectSubstates[]> = {
  IN_REVIEW: [
    'INITIAL',
    'NEW_DOCUMENT',
    'DOCUMENT_REVIEW',
    'DOCUMENT_CORRECTED',
    'DOCUMENT_OBSERVED',
    'CONTRACT_PENDING',
    'CONTRACT_PENDING_SIGNATURE',
    'CONTRACT_PENDING_ACTIVATION',
    'CREDENTIALS_SENT',
    'POP_SENT',
  ],
  COMPLETED: ['COMPLETED'],
  REJECTED: ['CONTRACT_NOT_SIGNED', 'MISSING_DOCUMENTATION', 'DOCUMENT_NOT_CORRECTED', 'DISCARDED'],
};

export const legalFormsFormatted: Record<string, string> = {
  AUTONOMO: 'Autónomo',
  MONOTRIBUTISTA: 'Monotributista',
  MONOTRIBUTISTA_AUTONOMO: 'Monotributista Autónomo',
  MUTUAL: 'Mutual',
  SA: 'Sociedad Anónima (SA)',
  SAS: 'Sociedad por Acciones Simplificada (SAS)',
  SAU: 'Sociedad Anónima Unipersonal (SAU)',
  SC: 'Sociedad Colectiva (SC)',
  SCA: 'Sociedad en Comandita por Acciones (SCA)',
  SCI: 'Sociedad en Comandita Simple (SCI)',
  SCS: 'Sociedad en Comandita por Socios (SCS)',
  SRL: 'Sociedad de Responsabilidad Limitada (SRL)',
  SH: 'Sociedad de Hecho (SH)',
};

export const backofficeErrorMessages: Record<string, string> = {
  HEADQUARTERS_COMBINATION_MISMATCH: 'Múltiples CUIT para la sucursal',
  HEADQUARTERS_NOT_FOUND: 'Punto de Venta inactivo',
  HEADQUARTERS_TAXPAYER_ID_MISMATCH: 'Inconsistencia entre el CUIT de la Sucursal y el cliente',
};
